<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "bx-tag",
  props: {
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    uppercase: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes() {
      const classes = ["bx-tag"];
      if (this.color) {
        classes.push(`bx-bg-color-${this.color}`);
      }
      if (this.uppercase) {
        classes.push(`bx-uppercase`);
      }
      return classes;
    }
  }
};
</script>
